import React from 'react';
import { Table, Button, Badge } from 'reactstrap';
import { Eye, CheckCircle, X, Award, Clock, Trash2 } from 'react-feather';

const UsersTable = ({ users, pagination, onViewDetail, onDelete, formatDate, isQuizMode = false }) => {
  return (
    <div className="table-responsive">
      <Table hover className="mb-0">
        <thead className="table-light">
          <tr>
            {isQuizMode && <th>Rank</th>}
            <th>#</th>
            <th>User ID</th>
            <th>Tên</th>
            <th>SĐT</th>
            <th>Role</th>
            <th>Followed OA</th>
            {isQuizMode && (
              <>
                <th>Điểm</th>
                <th>Đúng/Câu hỏi</th>
                <th>Thời gian</th>
                <th>Hoàn thành</th>
              </>
            )}
            {!isQuizMode && <th>Ngày tạo</th>}
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.userId || index}>
              {isQuizMode && (
                <td>
                  <Badge 
                    color={user.rank === 1 ? 'warning' : user.rank <= 3 ? 'success' : 'secondary'}
                    className="px-2 py-1"
                  >
                    <Award size={12} className="me-1" />
                    #{user.rank}
                  </Badge>
                </td>
              )}
              <td>{(pagination.page - 1) * pagination.limit + index + 1}</td>
              <td>
                <span className="font-monospace small">{user.userId}</span>
              </td>
              <td>{user.name || '-'}</td>
              <td>{user.phone || '-'}</td>
              <td>
                <Badge color="info" className="px-2 py-1">
                  {user.role_code || 'N/A'}
                </Badge>
              </td>
              <td>
                {user.followedOA ? (
                  <Badge color="success" className="px-2 py-1">
                    <CheckCircle size={12} className="me-1" />
                    Đã follow
                  </Badge>
                ) : (
                  <Badge color="secondary" className="px-2 py-1">
                    <X size={12} className="me-1" />
                    Chưa follow
                  </Badge>
                )}
              </td>
              {isQuizMode && user.attempt && (
                <>
                  <td>
                    <Badge color="primary" className="px-2 py-1">
                      {user.attempt.score || 0} điểm
                    </Badge>
                  </td>
                  <td>
                    <span className="small">
                      {user.attempt.correctAnswers || 0}/{user.attempt.totalQuestions || 0}
                    </span>
                  </td>
                  <td>
                    <span className="small">
                      <Clock size={12} className="me-1" />
                      {user.attempt.timeSpent || 0}s
                    </span>
                  </td>
                  <td className="small">{formatDate(user.attempt.completedAt)}</td>
                </>
              )}
              {!isQuizMode && <td className="small">{formatDate(user.createdAt)}</td>}
              <td className="text-center">
                <div className="d-flex gap-2 justify-content-center">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => onViewDetail(user.userId)}
                  >
                    <Eye size={14} className="me-1" />
                    Chi tiết
                  </Button>
                  {onDelete && (
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => onDelete(user.userId, user.name || user.userId)}
                    >
                      <Trash2 size={14} className="me-1" />
                      Xóa
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UsersTable;

